<template>
    
    <div v-if="serverDate">
        <conditions :policy="policy" :start="start" :end="end" :polid="policyid" />

        <signature class="mt-3 p-1" />
    </div>
</template>

<script>
import ImportantConditions from "@/Medical/components/ImportantConditions";
import Signature from "@/Medical/components/Signature";

export default {
  name: "ImportantConditions",
  components: {
    'conditions': ImportantConditions,
    Signature
  },
  data() {
    return {
        policy: this.$route.params.policy,
        start: this.$route.params.start,
        end: this.$route.params.end,
        policyid: this.$route.params.policyid,
        cont: this.$route.params.cont,
        cust: this.$route.params.cust,
        serverDate: null,
        data: null
    }
  },
  
  mounted() {
      this.$http.get("/policy/getdate").then((r) => {
          this.serverDate = r.data
      console.log(r.data);
    }).catch((e) => {
      console.log(e)
    })
  },
 
  
}
</script>

<style scoped>
header {
  background-color: #007a60 !important;
  color: #fafafa;
  box-shadow: 0 10px 0 #bd9bc5 !important;
}

.title {
  font-size: 18pt;
}

.description-box {
  background: #e6e0ec !important;
  color: black !important;
}

.h-center {
  transform: translateX(22%);
}

.green-text {
  color: #00A886;
}

.green-box {
  background: #007a60 !important;
  color: #fafafa;
}
</style>